<template>
  <div style="padding: 20px; overflow: scroll; height: 100%">
    <el-button
      @click.prevent="close"
      style="position: absolute; right: 10px; top: 10px"
      size="small"
      plain
      ><i class="fas fa-xmark"></i
    ></el-button>
    <h3 style="margin-top: -10px">Organization relationships</h3>
    <el-form
      ref="orgRelationshipForm"
      :model="form"
      :rules="validationRules"
      label-width="240px"
    >
      <el-form-item label="Council schools(sub-orgs)" prop="sub_organizations" v-if="orgType != 'SCHOOL'">
        <OrgSelectionAdmin
          @return-selection="updateSubOrgs"
          :multiple="true"
          :collapseTags="false"
          :initialSelection="form.sub_orgs"
          style="width: 94%"
        />
      </el-form-item>
      <el-form-item label="Multi school" prop="proxied_organizations" v-if="orgType == 'SCHOOL'">
        <OrgSelectionAdmin
          @return-selection="updateMultiSchools"
          :multiple="true"
          :collapseTags="false"
          :initialSelection="form.multi_schools"
          style="width: 94%"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit()"
          ><i class="fa-solid fa-database"></i> Save</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Vue from "vue";
import ApiService from "@/services/ApiService";
import OrgSelectionAdmin from "@/components/admin/OrgSelectionAdmin.vue";
export default Vue.extend({
  name: "OrgRelationshipModal",
  components: {
    OrgSelectionAdmin,
  },
  data() {
    return {
      form: {
        sub_orgs: [],
        multi_schools: [],
      },
      validationRules: {},
    };
  },
  computed: {},
  props: {
    organization_id: {
      type: Number,
      required: true,
    },
    orgType: {
      type: String,
      required: true
    }
  },
  methods: {
    getOrgRelationship(orgId) {
      ApiService.sadminApi.getOrgRelationship(orgId).then((resp) => {
        // this.form = resp.data;
        if (resp.data.has_multi_schools) {
          this.form.multi_schools = resp.data.has_multi_schools;
        }
        if (resp.data.has_sub_orgs) {
          this.form.sub_orgs = resp.data.has_sub_orgs;
        }
      });
    },
    updateMultiSchools(value) {
      this.form.multi_schools = value.organization_id;
    },
    updateSubOrgs(value) {
      this.form.sub_orgs = value.organization_id;
    },
    closeModal() {
      this.close();
    },
    onSubmit() {
      this.$refs["orgRelationshipForm"].validate((valid) => {
        if (!valid) {
          return;
        }
        const payload = {
          ...this.form,
        };
        if (this.id != 0) {
          payload.id = this.id;
        }

        ApiService.sadminApi
          .postOrgRelationship(this.organization_id, payload)
          .then((resp) => {
            this.$notify.info({
              title: "Saved",
              message: "Good things just happened!",
            });
            this.$emit("close");
          });
      });
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.getOrgRelationship(this.organization_id);
  },
});
</script>
<style scoped>
.longInput {
  min-width: 300px;
}
#statusResponseTable {
  background: white;
  padding: 3px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border: 1px solid #bbb;
  margin: auto;
  border-radius: 10px;
}
#statusResponseTable td {
  padding: 2px;
  min-width: 200px;
}
#statusResponseTable tr td:nth-child(1) {
  font-weight: bold;
}
table#statusResponseTable tbody tr:nth-child(2n) {
  background-color: whitesmoke;
}

#previewTable {
  border-collapse: collapse;
}
#previewTable thead {
  position: sticky; /* make the table heads sticky */
  top: 0px; /* table head will be placed from the top of the table and sticks to it */
  box-shadow: 0px 1px 2px #ccc;
}
#previewTable thead th {
  padding: 0px 5px;
  /* border-right: 1px solid #bbb; */
}
hr {
  opacity: 0.5;
}
label {
  font-weight: bold;
  /* min-width: 160px; */
  display: inline-block;
  line-height: 40px;
}
span.inlineButton {
  padding-left: 15px;
  display: inline-block;
}
th.headSmallCol {
  font-size: 8px;
  background: #f9f9f9;
  padding: 5px 0;
  box-shadow: 0px 1px 2px #ccc;
}
th.headSmallCol:nth-child(2n + 2) {
  color: orange;
  background: #f3f3f3;
}
table#previewTable tbody tr:nth-child(2n) {
  background-color: whitesmoke;
}
td.tableCol {
  font-size: 9px;
  border: solid 1px #e6e6e6;
  border-left: 0;
  border-right: 0;
  white-space: nowrap;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 5px 0px;
}
td.tableCol:nth-child(2n + 2) {
  /* background: #fff8f2; */
}
.selectAllBtn {
  float: left;
  margin-top: 6px;
  margin-right: 5px;
}
</style>
